import { COMPANIES, CONTACTS } from 'constants/Entities';

const BODY_LITERALS = [
    'label_marketing_campaigns_bulk_subscribe_eligible',
    'label_marketing_campaigns_bulk_subscribe_immediate',
];

const CONFIG_BY_ENTITY = {
    [COMPANIES.entity]: {
        title: 'title_marketing_campaigns_mark_accounts_as_subscribers_question',
        introLiteral: 'label_marketing_campaigns_bulk_subscribe_confirm_intro_accounts',
        confirmLiteral: 'action_mark_as_subscribed_accounts',
    },
    [CONTACTS.entity]: {
        title: 'title_marketing_campaigns_mark_contacts_as_subscribers_question',
        introLiteral: 'label_marketing_campaigns_bulk_subscribe_confirm_intro_contacts',
        confirmLiteral: 'action_mark_as_subscribed_contacts',
    },
};

export function buildMarketingBulkSubscribeConfirmPayload({
    entity,
    filterKey,
    selectedIds,
    bulkSelectedEntities,
}) {
    const literals = CONFIG_BY_ENTITY[entity?.entity];
    if (!literals || !filterKey) return null;

    return {
        entity,
        filterKey,
        selectedIds,
        ...literals,
        introParams: [bulkSelectedEntities],
        bodyLiterals: BODY_LITERALS,
    };
}
